module.exports = __webpack_public_path__ + "media/img/apple-icon-57x57-1c82c3b33ce755b0c0bd5db6a6e0c07b.png";